import HttpRequest from '@/utils/httpRequest';

export function list(query) {
    return HttpRequest({
        url: 'business/rulecourse/list',
        method: 'post',
        data :query
    });
}

export function info(query) {
    return HttpRequest({
        url: 'business/rulecourse/info/{id}',
        method: 'post',
        data :query
    });
}

export function infobySchoolId(schoolId) {
    return HttpRequest({
        url: 'business/rulecourse/info/school/'+schoolId,
        method: 'get',
    });
}

export function save(query) {
    return HttpRequest({
        url: 'business/rulecourse/save',
        method: 'post',
        data :query
    });
}

export function update(query) {
    return HttpRequest({
        url: 'business/rulecourse/update',
        method: 'post',
        data :query
    });
}

export function deleteObj(id) {
    return HttpRequest({
        url: 'business/rulecourse/delete',
        method: 'post',
        data :id
    });
}

export function clone(id) {
    return HttpRequest({
        url: 'business/rulecourse/clone',
        method: 'post',
        data :id
    });
}

export function bindSchool(data) {
    return HttpRequest({
        url: 'business/rulecourse/bindSchool',
        method: 'post',
        data :data
    });
}


export function queryRuleCoursePeriod(ruleCourseId) {
    return HttpRequest({
        url: 'business/rulecourseperiod/list',
        method: 'get',
        params:{
            page:1,
            limit:999999,
            ruleCourseId
        }
    });
}
export function saveRuleCoursePeriod(data) {
    return HttpRequest({
        url: 'business/rulecourse/saveRuleCoursePeriod',
        method: 'post',
        data :data
    });
}
export function updateRuleCoursePeriod(data) {
    return HttpRequest({
        url: 'business/rulecourse/updateRuleCoursePeriod',
        method: 'post',
        data :data
    });
}

export function deleteRuleCoursePeriod(id) {
    return HttpRequest({
        url: 'business/rulecourse/deleteRuleCoursePeriod',
        method: 'post',
        data :id
    });
}
export function saveRuleCousePeriodList(data) {
    return HttpRequest({
        url: 'business/rulecourse/saveRuleCousePeriodList',
        method: 'post',
        data :data
    });
}
